export default "__VITE_ASSET__Bqhg1K1w__"